import { createRequestTypes } from '../utils';

// export const USER_ROLE_LIST = createRequestTypes('userRole/USER_ROLE_LIST');
export const USER_ROLE_LIST_FOR_ROLES = createRequestTypes('userRole/USER_ROLE_LIST_FOR_ROLES');

